var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-affiliate-links-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var affiliateLinks = ref.affiliateLinks;
var isLoading = ref.isLoading;
var handleSubmit = ref.handleSubmit;
var canCreateDeepLink = ref.canCreateDeepLink;
return [_c('activation-brief-affiliate-links-view',{attrs:{"affiliate-links":affiliateLinks,"is-loading":isLoading,"can-create-deep-link":canCreateDeepLink},on:{"create-deep-link":handleSubmit}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }